import { IBaseParams } from '@interfaces/IBaseParam';
import { IBaseResponse } from '@interfaces/IBaseResponse';
import { useMutation, useQuery } from 'react-query';
import {
  getNotificationCountFromAPI,
  getNotificationsFromAPI,
  markNotificationReadByIdFromAPI,
  markNotificationsReadFromAPI,
} from './notification.api';
import { INotification, INotificationCount } from './notification.types';

export const actionGetNotifications = (
  params: IBaseParams,
  isEnabled: boolean = false,
) =>
  useQuery(
    ['actionGetNotifications', params],
    () => getNotificationsFromAPI(params),
    {
      select: (res) => (res?.data as IBaseResponse<INotification[]>) ?? null,
      enabled: isEnabled,
      refetchOnWindowFocus: false,
    },
  );

export const actionGetNotificationCount = (isEnabled: boolean = false) =>
  useQuery(
    ['actionGetNotificationCount'],
    () => getNotificationCountFromAPI(),
    {
      select: (res) => {
        const data = res?.data?.data as INotificationCount;
        return data ?? { count: 0 };
      },
      enabled: isEnabled,
      refetchInterval: 30000,
      refetchOnWindowFocus: false,
    },
  );

export const actionMarkNotificationsRead = () =>
  useMutation(() => markNotificationsReadFromAPI());

export const actionMarkNotificationReadById = () =>
  useMutation((id: string) => markNotificationReadByIdFromAPI(id));
